import { Card, styled } from "@mui/material";

export const StyledCard = styled(Card)(({ theme }) => ({
  background: theme.palette.custom.teal[50],
  borderColor: theme.palette.custom.teal[50],
}));
